module.exports = __webpack_public_path__ + "static/media/double-right-arrow.c97755db.svg";